/** Parsed from `organizations.sales_daily_checklist_config.lead_default_first_follow_up`. */

export type LeadDefaultFollowUpPolicy = {
  enabled: boolean;
  next_action_hot: string;
  next_action_warm: string;
  next_action_cold: string;
  due_hours_hot: number;
  due_hours_warm: number;
  due_hours_cold: number;
};

const DEFAULT_HOT = "Call customer and confirm next step";
const DEFAULT_WARM = "Send quote recap and schedule follow-up";
const DEFAULT_COLD = "Send light follow-up and keep warm";

export const DEFAULT_LEAD_DEFAULT_FOLLOW_UP_POLICY: LeadDefaultFollowUpPolicy = {
  enabled: false,
  next_action_hot: DEFAULT_HOT,
  next_action_warm: DEFAULT_WARM,
  next_action_cold: DEFAULT_COLD,
  due_hours_hot: 12,
  due_hours_warm: 24,
  due_hours_cold: 24,
};

function clampHours(n: unknown, fallback: number): number {
  const x = typeof n === "number" ? n : parseInt(String(n ?? ""), 10);
  if (!Number.isFinite(x) || x < 1 || x > 720) return fallback;
  return Math.round(x);
}

/** Read optional block from org `sales_daily_checklist_config` JSON. */
export function parseLeadDefaultFollowUpPolicy(rawConfig: unknown): LeadDefaultFollowUpPolicy {
  const base = { ...DEFAULT_LEAD_DEFAULT_FOLLOW_UP_POLICY };
  if (!rawConfig || typeof rawConfig !== "object" || Array.isArray(rawConfig)) return base;
  const c = rawConfig as Record<string, unknown>;
  const block = c.lead_default_first_follow_up;
  if (!block || typeof block !== "object" || Array.isArray(block)) return base;
  const b = block as Record<string, unknown>;
  return {
    enabled: b.enabled === true,
    next_action_hot: typeof b.next_action_hot === "string" && b.next_action_hot.trim() ? b.next_action_hot.trim() : DEFAULT_HOT,
    next_action_warm: typeof b.next_action_warm === "string" && b.next_action_warm.trim() ? b.next_action_warm.trim() : DEFAULT_WARM,
    next_action_cold: typeof b.next_action_cold === "string" && b.next_action_cold.trim() ? b.next_action_cold.trim() : DEFAULT_COLD,
    due_hours_hot: clampHours(b.due_hours_hot, DEFAULT_LEAD_DEFAULT_FOLLOW_UP_POLICY.due_hours_hot),
    due_hours_warm: clampHours(b.due_hours_warm, DEFAULT_LEAD_DEFAULT_FOLLOW_UP_POLICY.due_hours_warm),
    due_hours_cold: clampHours(b.due_hours_cold, DEFAULT_LEAD_DEFAULT_FOLLOW_UP_POLICY.due_hours_cold),
  };
}

export function nextActionForInterestLevel(
  interest: "hot" | "warm" | "cold" | null | undefined,
  policy: LeadDefaultFollowUpPolicy
): string {
  if (interest === "hot") return policy.next_action_hot;
  if (interest === "cold") return policy.next_action_cold;
  return policy.next_action_warm;
}

export function dueHoursForInterestLevel(
  interest: "hot" | "warm" | "cold" | null | undefined,
  policy: LeadDefaultFollowUpPolicy
): number {
  if (interest === "hot") return policy.due_hours_hot;
  if (interest === "cold") return policy.due_hours_cold;
  return policy.due_hours_warm;
}
